import React, { useEffect, useState } from 'react';
import adminApi from './adminApi';
import { Karte, Chip, Leer, Fehler, datumZeit } from './bausteine';

const GRUND_LABEL = {
  'stopp': 'STOPP',
  'testphase-abgelaufen': 'Test abgelaufen',
  'abo-beendet': 'gekündigt',
  'versand-fehlgeschlagen': 'Zustellung',
  'admin-pause': 'Admin-Pause',
};

const TabFunnel = () => {
  const [daten, setDaten] = useState(null);
  const [fehler, setFehler] = useState(null);

  useEffect(() => {
    adminApi.funnel().then(setDaten)
      .catch((e) => setFehler(e.response?.data?.error || e.message));
  }, []);

  if (fehler) return <Fehler>{fehler}</Fehler>;
  if (!daten) return <Leer>Lade …</Leer>;

  const summe = (w) => w.registrierungenAngehoerige + w.registrierungenSelbst;
  const beendetSumme = (w) => Object.values(w.beendet).reduce((a, b) => a + b, 0);

  return (
    <div className="space-y-6">
      <Karte titel="Pro Woche">
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="text-left text-gray-500 border-b">
                <th className="py-2 pr-4 font-medium">Woche</th>
                <th className="py-2 pr-4 font-medium">Registrierungen</th>
                <th className="py-2 pr-4 font-medium" title="Die betreute Person hat mindestens einmal geantwortet">
                  erste Antwort
                </th>
                <th className="py-2 pr-4 font-medium">Testphase</th>
                <th className="py-2 pr-4 font-medium">zahlend</th>
                <th className="py-2 font-medium">beendet</th>
              </tr>
            </thead>
            <tbody>
              {daten.wochen.map((w) => (
                <tr key={w.woche} className="border-b border-gray-50">
                  <td className="py-2 pr-4 whitespace-nowrap">
                    <span className="font-medium">{w.woche}</span>
                    <span className="block text-xs text-gray-400">ab {w.beginn}</span>
                  </td>
                  <td className="py-2 pr-4">
                    {summe(w) === 0 ? <span className="text-gray-300">–</span> : (
                      <>
                        <span className="font-semibold">{summe(w)}</span>
                        <span className="block text-xs text-gray-500">
                          {w.registrierungenAngehoerige} für Angehörige · {w.registrierungenSelbst} selbst
                        </span>
                      </>
                    )}
                  </td>
                  <td className="py-2 pr-4">
                    {w.ersteAntwortErhalten || <span className="text-gray-300">–</span>}
                  </td>
                  <td className="py-2 pr-4">
                    {w.testphaseAktiv || <span className="text-gray-300">–</span>}
                  </td>
                  <td className="py-2 pr-4">
                    {w.zahlend ? <Chip farbe="gruen">{w.zahlend}</Chip> : <span className="text-gray-300">–</span>}
                  </td>
                  <td className="py-2">
                    {beendetSumme(w) === 0 ? <span className="text-gray-300">–</span> : (
                      <div className="flex flex-wrap gap-1">
                        {Object.entries(w.beendet).filter(([, n]) => n > 0).map(([grund, n]) => (
                          <Chip key={grund} farbe="rot">{GRUND_LABEL[grund] || grund}: {n}</Chip>
                        ))}
                      </div>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <p className="mt-3 text-xs text-gray-500">
          „Erste Antwort“ ist der Moment, in dem der Dienst für dieses Konto zum
          ersten Mal nachweislich funktioniert hat.
        </p>
      </Karte>

      <Karte titel="Letzte Ereignisse">
        {daten.ereignisse.length === 0 ? <Leer>Noch keine Ereignisse.</Leer> : (
          <ul className="space-y-2">
            {daten.ereignisse.map((e) => (
              <li key={e.id} className="flex items-start gap-3 text-sm border-b border-gray-50 pb-2">
                <Chip farbe={e.art === 'stop' ? 'rot' : e.art === 'resume' ? 'gruen' : 'gelb'}>
                  {e.art === 'stop' ? 'Stopp' : e.art === 'resume' ? 'Wieder an' : 'Erinnerung'}
                </Chip>
                <span className="flex-1">
                  <span className="font-medium">{e.person}</span>
                  {' – '}{e.text}
                  <span className="block text-xs text-gray-400">
                    {datumZeit(e.createdAt)}
                    {e.art === 'stop' && !e.betreiberBenachrichtigt && (
                      <span className="text-red-600"> · Meldung an dich ist NICHT angekommen</span>
                    )}
                  </span>
                </span>
              </li>
            ))}
          </ul>
        )}
      </Karte>
    </div>
  );
};

export default TabFunnel;
